import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
const _excluded = ["className"];
/* eslint-disable */

// Wrapper for react-slick, see docs at https://react-slick.neostack.com/docs/api

import React, { Component } from 'react';
import SlickSlider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './_slider.scss';
const defaultResponsiveSettings = [{
  breakpoint: 10000,
  settings: {
    // slidesToShow: 4,
    slidesToScroll: 1
  }
}, {
  breakpoint: 1024,
  settings: {
    // slidesToShow: 3,
    slidesToScroll: 1
  }
}, {
  breakpoint: 992,
  settings: {
    // slidesToShow: 3,
    slidesToScroll: 1
  }
}, {
  breakpoint: 768,
  settings: {
    // slidesToShow: 2,
    slidesToScroll: 1
  }
}, {
  breakpoint: 450,
  settings: {
    // slidesToShow: 1,
    slidesToScroll: 1
  }
}];
let Slider = /*#__PURE__*/function (_Component) {
  function Slider() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Slider, _Component);
  var _proto = Slider.prototype;
  _proto.componentDidMount = function componentDidMount() {
    // this.slider.slickGoTo(1);
  };
  _proto.render = function render() {
    const _this$props = this.props,
      {
        className
      } = _this$props,
      otherProps = _objectWithoutProperties(_this$props, _excluded);
    let newClassName = 'lfs-slider ';
    newClassName += this.props.dots ? 'lfs-slider--has-dots ' : '';
    newClassName += className || '';
    const responsiveSettings = this.props.responsiveSettings ? this.props.responsiveSettings : defaultResponsiveSettings;
    return /*#__PURE__*/React.createElement(SlickSlider, Object.assign({
      className: newClassName,
      responsive: responsiveSettings,
      ref: slider => {
        this.slider = slider;
      }
    }, otherProps), this.props.children);
  };
  return Slider;
}(Component); // See docs at https://react-slick.neostack.com/docs/api for full propTypes
// to pass down to react-slick
Slider.defaultProps = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  gallery: false
};
export default Slider;